import { State } from 'app/redux';

export const getInsightsEntitlement = (state: State) => {
  return state.insightsEntitlement.insightsEntitlement.entitlement;
};
